<template>
  <!-- 头部整体盒子 -->
  <div id="header" class="container-fuild">
    <!-- 头部顶部 -->
    <!-- <div class="header-top container-fuild hidden-xs">
      <div class="container">
        <div class="server pull-left">
          <span class="glyphicon glyphicon-earphone"></span>888-888-888
          <span class="glyphicon glyphicon-envelope"></span>liyunkun_11@163.com
          <span class="glyphicon glyphicon-time"></span>7x24小时为您服务
        </div>
        <div class="shejiao pull-right">
          <span class="glyphicon glyphicon-hand-right"></span>赶快联系我们吧！
          <span class="glyphicon glyphicon-hand-left"></span>
        </div>
      </div>
    </div> -->
    <!-- 电脑导航 -->
    <div class="header-nav container hidden-xs">
      <!-- 导航logo -->
      <div class="header-nav-logo">
        <img style="height: 50px" :src="companyList.companyLogo" />
      </div>
      <!-- 导航内容 -->
      <ul class="header-nav-wrapper">
        <li
          v-for="(item, index) in navList"
          :key="index"
          :class="index == navIndex ? 'active' : ''"
          @click="navClick(index, item)"
        >
          <router-link :to="item.path">
            {{ item.name }}
            <span
              v-if="item.children.length > 0"
              class="glyphicon glyphicon-menu-down"
            ></span>
            <i class="underline"></i>
          </router-link>
          <dl v-if="item.children.length > 0">
            <dt v-for="(i, n) in item.children" :key="n">
              <router-link :to="i.path">{{ i.name }}</router-link>
            </dt>
          </dl>
        </li>
      </ul>
    </div>
    <!-- 手机导航 -->
    <div class="header-nav-m container-fuild visible-xs">
      <div class="header-nav-m-logo">
        <img class="center-block" :src="companyList.companyLogo" alt="logo" />
      </div>
      <!-- 导航栏 -->
      <div class="header-nav-m-menu text-center">
        {{ menuName }}
        <div
          class="header-nav-m-menu-wrapper"
          data-toggle="collapse"
          data-target="#menu"
          @click="menuClick"
        >
          <span :class="menuClass"></span>
        </div>
        <!-- 导航内容 -->
        <ul id="menu" class="header-nav-m-wrapper collapse">
          <li
            v-for="(item, index) in navList"
            :key="index"
            :class="index == navIndex ? 'active' : ''"
            @click="navClick(index, item.name)"
            data-toggle="collapse"
            data-target="#menu"
          >
            <router-link :to="item.path">
              {{ item.name }}
              <i class="underline"></i>
            </router-link>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Header",
  data() {
    return {
      id: 11,
      companyList: {
        companyLogo:
          "https://leosue-cms.oss-cn-beijing.aliyuncs.com/images/20230630/811a3c605cfb44b28fc07f2aef8a7aeb微信图片_20230630151600.png",
      },
      navIndex: sessionStorage.getItem("navIndex")
        ? sessionStorage.getItem("navIndex")
        : 0,
      menuName: "首页",
      menuClass: "glyphicon glyphicon-menu-down",
      navList: [
        {
          name: "首页",
          path: "/",
          children: [],
        },
        {
          name: "解决方案",
          // path: "/software",
          path: "/detail",
          children: [
            {
              name: "智慧医疗与大健康方案",
              // path: "/solution/fasion",
              path: "/detail",
            },
            {
              name: "智能制造与工业互联网",
              // path: "/solution/manufacturing",
              path: "/detail",
            },
          ],
        },
        {
          name: "产品中心",
          path: "/productCenter",
          children: [],
        },
        // {
        //   name: "新闻动态",
        //   path: "/news",
        //   children: [],
        // },
        {
          name: "客户故事",
          path: "/customerCase",
          children: [],
        },
        {
          name: "关于我们",
          path: "/aboutUs",
          children: [],
        },
        {
          name: "人才招聘",
          path: "/job",
          children: [],
        },
        // {
        //   name: "联系我们",
        //   path: "/contactus",
        //   children: []
        // }
      ],
      rawData: [
        {
          id: "088232c94d07424e8c4e3a3728e892d0",
          title: "智能制造与工业互联网",
          subhead: "Intelligent manufacturing and Industrial Internet",
          imgpath:
            "https://leosue-cms.oss-cn-beijing.aliyuncs.com/images/20230602/a937f77849d94028a83fe6efd4ca31ace267e6b8-650a-4bc9-9172-7352f34cd71b.png",
          type: "解决方案",
          detail:
            '<p>工业互联网平台以数据为驱动，一方面以解决企业在生产、经营管理等业务环节遇到的具体问题为根本出发点，通过价值导向，吸引企业上云上平台，解决纵向集成的问题；另一方面通过企业间的横向集成，集聚工业资源要素，实现行业产业链或区域产业集群的数字化升级，加速生产方式和产业形态创新变革<img src="https://leosue-cms.oss-cn-beijing.aliyuncs.com/images/20230602/4824d309b3464f679ca26a7464015522eb9bbbe3-9de6-4dca-beb3-b50453144835.png" contenteditable="false" style="font-size: 14px; max-width: 100%;"/></p><br/>',
          creator: null,
          creationTime: "2023-05-22 11:38:32",
          sort: null,
        },
        {
          id: "dbd7cd03e056459e9189301d9018d1ea",
          title: "智慧医疗与大健康方案",
          subhead: "Digital supply chain for fashion industry",
          imgpath:
            "https://leosue-cms.oss-cn-beijing.aliyuncs.com/images/20230602/d491f15ed00e4840b165b43cefb3a6018812f210-555f-43bc-9217-e9b1b838c379.png",
          type: "解决方案",
          detail:
            '<p style="text-align:center;"><b><font size="6">全链路的协作体系</font></b></p><p style="text-align:center;"><img src="https://leosue-cms.oss-cn-beijing.aliyuncs.com/images/20230607/4a95dc56febe4a378be9269728dcd9fc67f98d7a3ce644efa58c911efdb038c3scm.fe151e8.png" style="max-width:100%;" contenteditable="false" width="100%"/></p><p style="text-align:center;"><br/></p><p style="text-align:center;"></p><h1 style="text-align:center;"><font id="4a5z5" style="" size="6">打通供应链“任督二脉”</font></h1><div><font style="" size="6"><br/></font></div><img src="https://leosue-cms.oss-cn-beijing.aliyuncs.com/images/20230607/5a4c111d4dbb41bca4c2018c371abadcsection-1.c1de6ef.jpg" contenteditable="false" style="font-size: 14px; max-width: 100%;" width="100%"/><br/>',
          creator: null,
          creationTime: "2023-05-22 11:37:18",
          sort: null,
        },
      ],
    };
  },
  created() {
    this.getData();
    this.getCompany();
  },
  methods: {
    navClick(index, name) {
      // if (index == "1") {
      //   // 是解决方案,先获取数据
      // } else {
      // }
      this.navIndex = index;
      sessionStorage.setItem("navIndex", index);
      this.menuName = name;
    },
    menuClick() {
      if (this.menuClass == "glyphicon glyphicon-menu-down") {
        this.menuClass = "glyphicon glyphicon-menu-up";
      } else {
        this.menuClass = "glyphicon glyphicon-menu-down";
      }
    },
    // 获取解决方案列表
    getData() {
      var newData = this.rawData.map(function (item, index) {
        return {
          name: item.title,
          path: "/detail?itemId=" + item.id,
        };
      });
      this.navList[1].children = newData;
      this.navList[1].path = "/detail?itemId=" + this.rawData[0].id;
    },
    // getCompany () {
    //   this.http({
    //     method: "post",
    //     url: "/cms/api/CompanyInfo/companyInfoselect",
    //     data: {
    //       id: "11",
    //     },
    //   }).then((res) => {
    //     if (res.data.code == 200) {
    //       this.companyList = res.data.data;
    //     }
    //   });
    // },
  },
};
</script>
<style scoped>
/* 顶部 */
#header {
  background: #f4f4f4;
  transition: all ease 0.6s;
}
#header .header-top {
  height: 50px;
  color: #fff;
  font-size: 12px;
  line-height: 50px;
  background: #083055;
}
/* 顶部的图标 */
#header .header-top span {
  margin: 0 8px;
}
/* 导航栏 */
#header .header-nav {
  height: 110px;
}
/* 导航栏logo */
#header .header-nav .header-nav-logo {
  width: 100px;
  height: 100%;
  float: left;
  position: relative;
}
/* 导航栏logo图片 */
#header .header-nav .header-nav-logo img {
  height: 45px;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
}
/* 导航栏 导航容器 */
#header .header-nav-fixed .header-nav-wrapper {
  line-height: 50px;
}
#header .header-nav .header-nav-wrapper {
  line-height: 110px;
  float: right;
  margin: 0;
  max-width: 800px;
}
/* 导航栏 每个导航 */
#header .header-nav .header-nav-wrapper > li {
  float: left;
  margin: 0 15px;
  position: relative;
}
/* 导航栏 每个导航下面的 a 链接 */
#header .header-nav .header-nav-wrapper > li > a {
  color: #333333;
  font-size: 17px;
  font-weight: bold;
  padding: 15px 0;
  position: relative;
}
/* 导航栏 每个导航下面的 a 链接的下划线 */
#header .header-nav .header-nav-wrapper > li > a > i {
  display: block;
  position: absolute;
  bottom: -2px;
  left: 50%;
  width: 0;
  height: 2px;
  opacity: 0;
  transition: all 0.6s ease;
  background-color: #083055;
}
/* 导航栏 每个导航下面的 a 链接的右侧小三角 */
#header .header-nav .header-nav-wrapper > li > a > span {
  font-size: 12px;
  transition: transform ease 0.5s;
}
/* 导航栏 每个导航下面的 a 链接 鼠标滑上去的样式 */
#header .header-nav .header-nav-wrapper > li > a:hover {
  color: #083055;
  text-decoration: none;
}
/* 导航栏 每个导航下面的 a 链接 鼠标滑上去下划线的样式 */
#header .header-nav .header-nav-wrapper > li > a:hover .underline {
  opacity: 1;
  width: 100%;
  left: 0;
}
/* 导航栏 每个导航下面的 a 链接 鼠标滑上去三角标的样式 */
#header .header-nav .header-nav-wrapper > li > a:hover span {
  transform: rotate(180deg);
}
/* 导航栏 每个导航下面的 a 链接 鼠标点击后的样式 */
#header .header-nav .header-nav-wrapper > li.active > a {
  color: #083055;
  text-decoration: none;
  border-bottom: 2px solid #083055;
}
/* 导航栏 每个导航下面的二级导航容器 */
#header .header-nav .header-nav-wrapper > li > dl {
  display: none;
  position: absolute;
  width: 168px;
  top: 80%;
  left: 0;
  z-index: 999999;
  box-shadow: 0 0 3px 1px #ccc;
  background: #fff;
}
/* 导航栏 每个导航下面的二级导航容器的每个导航 */
#header .header-nav .header-nav-wrapper > li > dl > dt {
  width: 100%;
  padding: 10px;
  border-bottom: 1px solid #ccc;
}
/* 导航栏 每个导航下面的二级导航容器的每个导航 当鼠标滑上时的样式*/
#header .header-nav .header-nav-wrapper > li > dl > dt > a:hover {
  text-decoration: none;
}
/* 导航栏 滑上一级导航显示二级导航 */
#header .header-nav .header-nav-wrapper > li:hover dl {
  display: block;
}
#header .header-nav .header-nav-wrapper > li > dl > dt:hover {
  cursor: pointer;
  background: #ccc;
}
@media screen and (max-width: 997px) {
  #header .header-nav-m {
    position: relative;
  }
  /* 导航栏logo容器 */
  #header .header-nav-m .header-nav-m-logo {
    height: 80px;
    position: relative;
  }
  /* 导航栏logo图片 */
  #header .header-nav-m .header-nav-m-logo img {
    height: 45px;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
  }
  /* 导航栏  菜单容器 */
  #header .header-nav-m .header-nav-m-menu {
    color: #fff;
    height: 50px;
    font-size: 20px;
    line-height: 50px;
    background: #083055;
    position: relative;
  }
  /* 导航栏 菜单图标 */
  #header .header-nav-m .header-nav-m-menu-wrapper {
    position: absolute;
    top: 50%;
    right: 20px;
    margin-top: -20px;
    width: 50px;
    height: 40px;
    color: #fff;
    z-index: 999999;
    font-size: 12px;
  }
  /* 导航栏 */
  #header .header-nav-m .header-nav-m-wrapper {
    position: absolute;
    top: 50px;
    left: 0;
    width: 100%;
    background: #083055;
    z-index: 9999999;
  }
  /* 导航栏 每个导航 */
  #header .header-nav-m .header-nav-m-wrapper > li {
    height: 40px;
    line-height: 40px;
    border-bottom: 1px solid #ccc;
  }
  /* 导航栏 每个导航下面的 a 链接 */
  #header .header-nav-m .header-nav-m-wrapper > li > a {
    color: #fff;
    font-size: 15px;
    font-weight: bold;
    padding: 15px 0;
    position: relative;
  }
  /* 导航栏 每个导航下面的 a 链接的右侧小三角 */
  #header .header-nav .header-nav-wrapper > li > a > span {
    font-size: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue